import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "https://team.mira.cloud/api/teleg_dev/v2.1",
});

// Add a request interceptor to include the access token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
